function startOfMonth(d) {
  return new Date(d.getFullYear(), d.getMonth(), 1);
}

function formatMonth(date) {
  return date.toLocaleDateString('fr-FR', {month: 'long', year: 'numeric'}).replace(/^./, c => c.toUpperCase());
}

export {startOfMonth, formatMonth};
